<template>
  <b-button
    variant="secondary"
    @click="back"
    class="mb-4"
  >

  <b-icon
    icon="arrow-left" />
    戻る
  </b-button>
</template>

<script>
export default {
  methods: {
    back () {
      const action = this.$store.getters['back/getAttr']('action')
      if (action) {
        action()
        this.$store.state.commit('back/setAttr', {
          name: action,
          value: null
        })
        return
      }

      this.$router.go(-1)
    }
  }
}
</script>
